import React, { useEffect, useState } from 'react';

const DemoRequestsPage = () => {
  const [demoRequests, setDemoRequests] = useState([]);
  const [error, setError] = useState('');

  // Fetch demo requests when the component mounts
  useEffect(() => {
    const fetchDemoRequests = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/demoRequests`);
        if (!response.ok) {
          throw new Error('Failed to fetch demo requests');
        }
        const data = await response.json();
        setDemoRequests(data); // Assuming the response is an array
      } catch (err) {
        setError(err.message);
      }
    };

    fetchDemoRequests();
  }, []);

  return (
    <div className="container mx-auto p-6 m-20">
      <h1 className="text-3xl font-semibold mb-4">Demo Requests For Gurukul ERP</h1>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 border-b border-gray-200">Sr No.</th>
              <th className="py-2 px-4 border-b border-gray-200">School</th>
              <th className="py-2 px-4 border-b border-gray-200">Name</th>
              <th className="py-2 px-4 border-b border-gray-200">Email</th>
              <th className="py-2 px-4 border-b border-gray-200">Phone</th>
              <th className="py-2 px-4 border-b border-gray-200">City</th>
              <th className="py-2 px-4 border-b border-gray-200">Message</th>
              <th className="py-2 px-4 border-b border-gray-200">Demo Type</th>
            </tr>
          </thead>
          <tbody>
            {demoRequests.length > 0 ? (
              demoRequests.map((request, index) => (
                <tr key={request._id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b border-gray-200">{index + 1}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.school}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.name}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.email}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.phone}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.city}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.message}</td>
                  <td className="py-2 px-4 border-b border-gray-200">{request.demoType}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="py-4 text-center">No demo requests found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DemoRequestsPage;
